import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Header } from '@/components/header/header';
import { Footer } from '@/components/footer/footer';

export const Route = createFileRoute('/_public')({
  component: PublicLayout,
});

// eslint-disable-next-line react-refresh/only-export-components
function PublicLayout() {
  return (
    <div className="bg-background min-h-screen">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
